// Copyright (c) 2016 Deere & Company

import ProductSearch from '../../product/search/state-connector';

export default {
    component: ProductSearch,
    name: 'SEARCH',
    path: 'search'
};



// WEBPACK FOOTER //
// ./src/routes/products/search-route.js